import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTheme } from "@mui/material/styles";
import { cancelButtonSx, dangerButtonSx } from "../actionStyles";
import { useNavigate } from "react-router-dom";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useAuth } from "../../../contexts/AuthContext";
import { useDeleteAccountMutation } from "../../../api/userApi";
import { useToast } from "../../../components/ui/Toast";

const CONFIRM_PHRASE = "SIL";

export default function DeleteAccountConfirm({ open, onClose }) {
  const { t } = useScriptMode();
  const { clearSession } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const [phrase, setPhrase] = useState("");
  const mode = useTheme().palette.mode;

  useEffect(() => { if (open) setPhrase(""); }, [open]);

  const [deleteAccount, { isLoading }] = useDeleteAccountMutation();

  const onConfirm = async () => {
    const result = await deleteAccount();
    if (result.error) {
      toast.error(result.error.message || t("account_delete_error"));
      return;
    }
    toast.success(t("account_delete_success"));
    clearSession();
    navigate("/giris", { replace: true });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("profile_delete_confirm_title")}</DialogTitle>
      <DialogContent className="flex flex-col gap-4">
        <p className="text-base text-terakkiNeutral">{t("profile_delete_confirm_body")}</p>
        <p className="text-base">{t("profile_delete_confirm_phrase")}</p>
        <TextField value={phrase} onChange={(e) => setPhrase(e.target.value)} placeholder={CONFIRM_PHRASE} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ ...cancelButtonSx(mode), borderRadius: 999, px: 2 }}>
          {t("cancel")}
        </Button>
        <LoadingButton
          color="error"
          variant="contained"
          loading={isLoading}
          disabled={phrase !== CONFIRM_PHRASE}
          onClick={onConfirm}
          sx={{ ...dangerButtonSx, borderRadius: 999, px: 2 }}
        >
          {t("delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
